import React from "react";
import "./cardproduct.css";
import { Link } from "react-router-dom";
import { baseUrlImg } from "../../Api/baseUrl";

const Cardproduct = ({ AllCar, update, handleShowDelete, userData }) => {
  return (
    <div>
      <ul className="cards clearfix">
        {AllCar && AllCar.results && AllCar.results.length >= 0
          ? AllCar.results.map((item,idx) => (
              <li key={idx}>
                {userData && userData.user_type === "admin" ? (
                  <div className="e-d">
                    <span onClick={() => update(item)}>تعديل</span>
                    <span onClick={() => handleShowDelete(item)}>حذف</span>
                  </div>
                ) : null}

                <figure className="product-card">
                  <Link
                    to={`${
                      userData && userData.user_type === "admin"
                        ? `/admin/car/delatis/${item.id}`
                        : `/user/car/delatis/${item.id}`
                    }`}
                  >
                    <img
                      className="product-card-img"
                      alt=""
                      src={baseUrlImg + item.image_url}
                    />
                    <figcaption>
                      <h5 className="product-card-title">
                        {item.category.name + " " + item.model}
                      </h5>
                      <p>{item.year_car}</p>
                      <p className="product-card-address">
                        <i className="fa-solid fa-car"></i>
                        {item.car_type === "F"
                          ? "اول مالك"
                          : item.car_type === "D"
                          ? "معاقين"
                          : item.car_type === "Z"
                          ? "الزيرو"
                          : null}
                      </p>
                      <div className="product-card-price">
                        <span className="price-savings">Save 25%</span>
                        <s className="original-price">1000000 جنية</s>
                        <p className="amount-price">
                          {/* <span className="from">starting at</span> */}
                          {item.price}جنية
                          {/* <span className="from">/night</span> */}
                        </p>
                      </div>
                    </figcaption>
                  </Link>
                </figure>
              </li>
            ))
          : null}
        {/* <li>
            
          <figure className="product-card">
            <a href="2#">
              <img
                className="product-card-img"
                alt=""
                src={img2}
              />
              <figcaption>
                <h5 className="product-card-title">Product Title</h5>
                <p>
                  Lorem ipsum dolor sit amet, nisl rebum moderatius ut pri, ius
                  te dico exerci, legimus facilis expetendis
                </p>
                <p className="product-card-address">
                  <i className="fa fa-map-marker"></i>Address information
                </p>
                <div className="product-card-price">
                  <span className="price-savings">Save 25%</span>
                  <s className="original-price">$176</s>
                  <p className="amount-price">
                    <span className="from">starting at</span>
                    $99<span className="from">/night</span>
                  </p>
                </div>
              </figcaption>
            </a>
          </figure>
        </li>
        <li>
          <figure className="product-card">
            <a href="2#">
              <img
                className="product-card-img"
                alt=""
                src={img3}
              />
              <figcaption>
                <h5 className="product-card-title">Product Title</h5>
                <p>
                  Lorem ipsum dolor sit amet, nisl rebum moderatius ut pri, ius
                  te dico exerci, legimus facilis expetendis
                </p>
                <p className="product-card-address">
                  <i className="fa fa-map-marker"></i>Address information
                </p>
                <div className="product-card-price">
                  <span className="price-savings">Save 25%</span>
                  <s className="original-price">$176</s>
                  <p className="amount-price">
                    <span className="from">starting at</span>
                    $99<span className="from">/night</span>
                  </p>
                </div>
              </figcaption>
            </a>
          </figure>
        </li>
        <li>
          <figure className="product-card">
            <a href="2#">
              <img
                className="product-card-img"
                alt=""
                src={img1}
              />
              <figcaption>
                <h5 className="product-card-title">Product Title</h5>
                <p>
                  Lorem ipsum dolor sit amet, nisl rebum moderatius ut pri, ius
                  te dico exerci, legimus facilis expetendis
                </p>
                <p className="product-card-address">
                  <i className="fa fa-map-marker"></i>Address information
                </p>
                <div className="product-card-price">
                  <span className="price-savings">Save 25%</span>
                  <s className="original-price">$176</s>
                  <p className="amount-price">
                    <span className="from">starting at</span>
                    $99<span className="from">/night</span>
                  </p>
                </div>
              </figcaption>
            </a>
          </figure>
        </li>
        <li>
          <figure className="product-card">
            <a href="2#">
              <img
                className="product-card-img"
                alt=""
                src={img2}
              />
              <figcaption>
                <h5 className="product-card-title">Product Title</h5>
                <p>
                  Lorem ipsum dolor sit amet, nisl rebum moderatius ut pri, ius
                  te dico exerci, legimus facilis expetendis
                </p>
                <p className="product-card-address">
                  <i className="fa fa-map-marker"></i>Address information
                </p>
                <div className="product-card-price">
                  <span className="price-savings">Save 25%</span>
                  <s className="original-price">$176</s>
                  <p className="amount-price">
                    <span className="from">starting at</span>
                    $99<span className="from">/night</span>
                  </p>
                </div>
              </figcaption>
            </a>
          </figure>
        </li>
        <li>
          <figure className="product-card">
            <a href="2#">
              <img
                className="product-card-img"
                alt=""
                src="https://2.bp.blogspot.com/-eR7OIV0go7U/UdJxVSMzHeI/AAAAAAAAZNA/-is7Wx1eQyA/s600/DUSIT-THANI-HOTEL-MALDIVES_TRAVEL_SUMMER-TRAVEL_TROPICAL-VACATION-10.jpg"
              />
              <figcaption>
                <h5 className="product-card-title">Product Title</h5>
                <p>
                  Lorem ipsum dolor sit amet, nisl rebum moderatius ut pri, ius
                  te dico exerci, legimus facilis expetendis
                </p>
                <p className="product-card-address">
                  <i className="fa fa-map-marker"></i>Address information
                </p>
                <div className="product-card-price">
                  <span className="price-savings">Save 25%</span>
                  <s className="original-price">$176</s>
                  <p className="amount-price">
                    <span className="from">starting at</span>
                    $99<span className="from">/night</span>
                  </p>
                </div>
              </figcaption>
            </a>
          </figure>
        </li>
        <li>
          <figure className="product-card">
            <a href="2#">
              <img
                className="product-card-img"
                alt=""
                src="https://2.bp.blogspot.com/-eR7OIV0go7U/UdJxVSMzHeI/AAAAAAAAZNA/-is7Wx1eQyA/s600/DUSIT-THANI-HOTEL-MALDIVES_TRAVEL_SUMMER-TRAVEL_TROPICAL-VACATION-10.jpg"
              />
              <figcaption>
                <h5 className="product-card-title">Product Title</h5>
                <p>
                  Lorem ipsum dolor sit amet, nisl rebum moderatius ut pri, ius
                  te dico exerci, legimus facilis expetendis
                </p>
                <p className="product-card-address">
                  <i className="fa fa-map-marker"></i>Address information
                </p>
                <div className="product-card-price">
                  <span className="price-savings">Save 25%</span>
                  <s className="original-price">$176</s>
                  <p className="amount-price">
                    <span className="from">starting at</span>
                    $99<span className="from">/night</span>
                  </p>
                </div>
              </figcaption>
            </a>
          </figure>
        </li>
        <li>
          <figure className="product-card">
            <a href="2#">
              <img
                className="product-card-img"
                alt=""
                src="https://2.bp.blogspot.com/-eR7OIV0go7U/UdJxVSMzHeI/AAAAAAAAZNA/-is7Wx1eQyA/s600/DUSIT-THANI-HOTEL-MALDIVES_TRAVEL_SUMMER-TRAVEL_TROPICAL-VACATION-10.jpg"
              />
              <figcaption>
                <h5 className="product-card-title">Product Title</h5>
                <p>
                  Lorem ipsum dolor sit amet, nisl rebum moderatius ut pri, ius
                  te dico exerci, legimus facilis expetendis
                </p>
                <p className="product-card-address">
                  <i className="fa fa-map-marker"></i>Address information
                </p>
                <div className="product-card-price">
                  <span className="price-savings">Save 25%</span>
                  <s className="original-price">$176</s>
                  <p className="amount-price">
                    <span className="from">starting at</span>
                    $99<span className="from">/night</span>
                  </p>
                </div>
              </figcaption>
            </a>
          </figure>
        </li>
        <li>
          <figure className="product-card">
            <a href="2#">
              <img
                className="product-card-img"
                alt=""
                src="https://2.bp.blogspot.com/-eR7OIV0go7U/UdJxVSMzHeI/AAAAAAAAZNA/-is7Wx1eQyA/s600/DUSIT-THANI-HOTEL-MALDIVES_TRAVEL_SUMMER-TRAVEL_TROPICAL-VACATION-10.jpg"
              />
              <figcaption>
                <h5 className="product-card-title">Product Title</h5>
                <p>
                  Lorem ipsum dolor sit amet, nisl rebum moderatius ut pri, ius
                  te dico exerci, legimus facilis expetendis
                </p>
                <p className="product-card-address">
                  <i className="fa fa-map-marker"></i>Address information
                </p>
                <div className="product-card-price">
                  <span className="price-savings">Save 25%</span>
                  <s className="original-price">$176</s>
                  <p className="amount-price">
                    <span className="from">starting at</span>
                    $99<span className="from">/night</span>
                  </p>
                </div>
              </figcaption>
            </a>
          </figure>
        </li> */}
      </ul>
    </div>
  );
};

export default Cardproduct;
